export default store => store.profile;
